import * as React from 'react';
import '../cssdirect/App.css'
import Icon from './Icon'
import Wind from './Wind'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDroplet } from '@fortawesome/free-solid-svg-icons'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import Input from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import PinDropIcon from '@mui/icons-material/PinDrop';
import { useState, useEffect } from 'react';
const Daily = ({coord, weather, main, visibility, wind, clouds, sys, timezone, name, dt, setCity, city, getWeather, handleSubmit}) => {
    const [time, setTime] = useState('')

    function timeConverter(dt){
        var a = new Date(dt * 1000);
        var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var hour = a.getHours();
        var min = a.getMinutes();
        var time = "as of "+hour+":"+min+", "+month+" "+date+" UTC";
        return time;
      }
  
      useEffect(()=>{
        setTime(timeConverter(dt))
        console.log(timeConverter(dt))
      },[])
  return (
    <>
            
            <div className="wrapper">
            <section className='wContainer'>
                <div className="time">{time}</div>
                <div className="extra">
                        <Wind {...wind}/>
                        <h3 className="humid"><FontAwesomeIcon icon={faDroplet}/> {main.humidity}%</h3>
                        <h3 className="pressure">{main.pressure} hPa</h3>
                    </div>
                    <div className="main">                    
                    <div><Icon condition={weather[0].main}/></div>
                    <h3 className='cond'>{weather[0].description}</h3>
                    <h3 className='temp'>{Math.round(main.temp)}° F</h3>
                    <div className="wWrapper">
                        <h4 className="low">Min: {Math.round(main.temp_min)}°</h4>
                        <h4 className="high">Max: {Math.round(main.temp_max)}°</h4>
                    </div></div>

                </section>
            </div>
    </>
  )
}

export default Daily